import React from "react";
import "./LinkTree.css";
import { links } from "../../data/data";
import LinkButton from "../../components/LinkButton/LinkButton";
import BackButton from '../../components/BackButton/BackButton';
// import Banner from '../../assets/CDiagBanner.jpg';
import Banner from "../../assets/SDiagBanner.jpg";

import { FaSpotify, FaApple, FaYoutube, FaSoundcloud } from 'react-icons/fa';
import { SiBeatport } from 'react-icons/si';

function LinkTree() {
    // toggle this to control the live indicator
    const isLive = true;

    return (
        <div 
            className="linktree"
            style={{ backgroundImage: `url(${Banner})` }}
        >
            <BackButton label="Back to Site" className="linktree__back-floating" />
            <div className="linktree__hero">
                <div className="linktree__hero-overlay" />
                {isLive && (
                    <div className="linktree__hero-badge">
                        <span className="live-badge" aria-hidden="true">
                            <span className="live-dot" />
                            LIVE
                        </span>
                    </div>
                )}
                {/* <div className="linktree__hero-inner">
                    <BackButton label="Back to site" />
                    <h1 className="linktree__title">Stream Diagnostic</h1>
                    <p className="linktree__subtitle">Listen on your favorite platforms</p>
                </div> */}
            </div>
            <div className="linktree__list">
                {links.map((link, index) => {
                    let Icon = null;
                    if (link.type === 'spotify') Icon = FaSpotify;
                    else if (link.type === 'beatport') Icon = SiBeatport;
                    else if (link.type === 'soundcloud') Icon = FaSoundcloud;
                    else if (link.type === 'youtube') Icon = FaYoutube;
                    else if (link.type === 'apple') Icon = FaApple;

                    const style = link.iconColor ? { '--link-icon-hover-color': link.iconColor, '--link-icon-color': link.iconColor } : undefined;

                    return <LinkButton key={index} title={link.title} url={link.url} Icon={Icon} style={style} />
                })}
            </div>            
        </div>
    );
};

export default LinkTree;